/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import PartnerLGCNSImg from "../../Sections/SectionPartners_lg_cns.png";
import PartnerLGScienceImg from "../../Sections/SectionPartners_lg_science_park.png";
import PartnerYoungwooDigiImg from "../../Sections/SectionPartners_youngwoo_digital.png";
import PartnerSamsungSDSImg from "../../Sections/SectionPartners_samsung_sds.png";
import PartnerServeOneImg from "../../Sections/SectionPartners_serve_one.png";
import PartnerSMEnterImg from "../../Sections/SectionPartners_sm_entertainment.png";

import DetailSecuDocuImg from './DetailsSecuritySolutionSecuDocu.png';
import DetailSecuDocuSensorGateImg from './DetailsSecuritySolutionSecuDocuSensorGate.png';
import DetailSecuDocuSensorStandImg from './DetailsSecuritySolutionSecuDocuSensorStand.png';
import DetailSecuDocuSensorFloormatImg from './DetailsSecuritySolutionSecuDocuSensorFloormat.png';
import DetailSecuDocuHandheldDetectorImg from './DetailsSecuritySolutionSecuDocuHandheldDetector.png';
import DetailSecuDocuSecurePrintingImg from './DetailsSecuritySolutionSecuDocuSecurePrinting.png';

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const SubSection = styled.div`
  margin-bottom: 50px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 16px 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HighlightText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 20px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;

const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
`;
const DivFlexboxNoWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const DivFlexItemNoWrap = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  padding-top: 20px;
`;
const ImgFlexItemNoWrap = styled.img`
  width: 100%;
`;

const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const DivIndent20 = styled.div`
  margin-left: 20px;
`;

class DetailsSecuritySolutionSecuDocu extends Component {
  render() {
    return (
      <div className="DetailsSecuritySolution">

        <Section className="section">
          <ContainerFluid className="container-fluid">

            <SubSection className="Intro">
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 고객사의 지속가능한 경쟁력 확보를 위해서는 영업기밀, 연구자산 등에 대한 적극적인 보호가 필요다는 것을 잘 알고 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>유출방지 기능성 보안용지 SecuDocu™와 보안프린터를 통해 고객사의 보안향상에 일조하고자 합니다. 고객사 보안 현황 점검 및 컨설팅, 보안솔루션 공급, 보안솔루션 운영, 유지 및 보수에 이르기까지 폭넓은 기업보안 관련 서비스를 제공합니다.</p>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><img src={DetailSecuDocuImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailSecuDocuSensorGateImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailSecuDocuHandheldDetectorImg}/></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

            <SubSection className="Features">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">특징 및 장점</span>
              </HighlightText>
              <div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>1.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>종이가 옷이나 가방 속에 있어도 탐지 가능</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>2.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>종이를 접거나 구기는 등 모양의 변형이 있을 때에도 탐지 가능</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>3.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>기존 OA기기와 호환</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>4.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>보안성의 임의적 부여를 배제함으로써 내부통제효과 탁월</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>5.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>유출 시점에 탐지하므로, 기밀유출을 사전에 방지하는 효과</span>
                  </DivIndent20>
                </div>
                <div style={{position:'relative'}}>
                  <SpanAbsoluteBold>6.</SpanAbsoluteBold>
                  <DivIndent20>
                    <span>네트웍보안, 물리적 보안의 강화로 최근 빈발하는 출력물을 통한 기밀유출에 가장 효과적인 보안 수단을 제공</span>
                  </DivIndent20>
                </div>
              </div>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">감지설비</span>
              </HighlightText>

              <div className="header-text-300" css={CssHeaderText300}>
                EM(Electromarnetic)감지 원리를 이용한 안테나는 2개 1조로 1 Lane을 구성하는 스탠드형 안테나, 발목하단부 검색을 위한 발판형(Floormat type) 안테나, 상세검색을 위한 휴대형(Handheld type)로 구성
              </div>

              <DivFlexboxWrap className="DivFlexboxWrap">
                <DivFlexItem><img src={DetailSecuDocuSensorStandImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailSecuDocuSensorFloormatImg}/></DivFlexItem>
                <DivFlexItem><img src={DetailSecuDocuHandheldDetectorImg}/></DivFlexItem>
              </DivFlexboxWrap>
            </SubSection>

            <SubSection className="SecurePrinting">
              <HighlightText className="header-text">
                <span className="CssHeaderText400">보안프린터</span>
              </HighlightText>

              <div className="header-text-300" css={CssHeaderText300}>
                SecuDocu™ 도입 이후 내부 사용자의 부정용지 사용 제한을 위한 솔루션
                <br/>
                전자감응 보안용지를 급지할 때에만 정상동작을 수행하는 OA기기 도입
              </div>

              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailSecuDocuSecurePrintingImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
            </SubSection>

          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default DetailsSecuritySolutionSecuDocu;
